import { USE_MOCKS } from '@/lib/mocks';
import { authContainer } from '@/modules/auth/di/container';
import { RankingApiDatasource } from '../data/datasources/ranking-api.datasource';
import { RankingMockDatasource } from '../data/datasources/ranking-mock.datasource';
import { RankingRepositoryImpl } from '../data/repositories/ranking.repository.impl';

const datasource = USE_MOCKS
  ? new RankingMockDatasource(() => authContainer.currentUserId())
  : new RankingApiDatasource();

export const rankingContainer = {
  repository: new RankingRepositoryImpl(datasource),
};
